import { call, put, select } from 'redux-saga/effects';
import { displaySimpleNotification } from 'features/notifications/simple-notifications/displaySimpleNotification';
import { sendPushContentSaga } from 'features/layout/features/content/sagas/sendPushContentSaga';
import {
  lockedContentChanged,
  selectCurrentOpenedContent,
} from 'features/layout/features/content/contentSlice';
import { ContentData } from 'features/layout/features/content/types';
import { Action } from '@reduxjs/toolkit';
import i18n from 'i18n';

export function* lockContentSaga() {
  yield call(sendPushContentSaga, true);

  const currentContentData: ContentData = yield select(selectCurrentOpenedContent);

  if (!currentContentData) {
    return;
  }

  yield put(lockedContentChanged(currentContentData));

  const notificationThunk: Action = yield call(displaySimpleNotification, {
    content: i18n.t('notifications:multi_tabs.content_locked'),
  });

  yield put(notificationThunk);
}
